var React = require('react');

function Pinterest (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"pinterest","d":"M12.633,0A12.594,12.594,0,0,0,8.027,24.331a12.091,12.091,0,0,1,.042-3.618c.229-.985,1.476-6.261,1.476-6.261a4.577,4.577,0,0,1-.374-1.866c0-1.752,1.019-3.058,2.287-3.058a1.585,1.585,0,0,1,1.6,1.773,24.844,24.844,0,0,1-1.05,4.2,1.834,1.834,0,0,0,1.871,2.281c2.246,0,3.972-2.364,3.972-5.764A4.978,4.978,0,0,0,12.57,6.894a5.459,5.459,0,0,0-5.708,5.463A4.907,4.907,0,0,0,7.8,15.229a.374.374,0,0,1,.083.363c-.094.394-.312,1.254-.354,1.431-.052.228-.187.28-.426.166-1.58-.736-2.568-3.027-2.568-4.883,0-3.97,2.89-7.62,8.349-7.62,4.377,0,7.787,3.11,7.787,7.277,0,4.344-2.745,7.837-6.55,7.837a3.36,3.36,0,0,1-2.89-1.451l-.79,3a13.7,13.7,0,0,1-1.57,3.307A12.654,12.654,0,0,0,25.244,12.616,12.588,12.588,0,0,0,12.633,0Z","fill":"#231f20"}));
}

Pinterest.defaultProps = {"width":"25.244","height":"25.212","viewBox":"0 0 25.244 25.212"};

module.exports = Pinterest;

Pinterest.default = Pinterest;
